import t from "./Highlight.vue_rollup-plugin-vue=script.js";
export default (function (t, i, e, r, h, n, s, a) {
  var g = ("function" == typeof e ? e.options : e) || {};
  return g.__file = "Highlight.vue", g.render || (g.render = t.render, g.staticRenderFns = t.staticRenderFns, g._compiled = !0, h && (g.functional = !0)), g._scopeId = r, g;
})({
  render: function render() {
    var t = this.$createElement;
    return (this._self._c || t)("ais-highlighter", {
      attrs: {
        hit: this.hit,
        attribute: this.attribute,
        "highlighted-tag-name": this.highlightedTagName,
        suit: this.suit,
        "highlight-property": "_highlightResult",
        "pre-tag": "<mark>",
        "post-tag": "</mark>"
      }
    });
  },
  staticRenderFns: []
}, 0, t, void 0, !1);